"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M14.704 8.122c0 1.718-1.445 3.123-3.21 3.123-1.767 0-3.212-1.405-3.213-3.123C8.281 6.405 9.727 5 11.493 5c1.765 0 3.211 1.405 3.211 3.122zM11.493 13.534C8.977 13.534 4 14.731 4 17.177v2.81h15.14v-2.81c0-2.446-5.13-3.643-7.647-3.643z" }), "User");
//# sourceMappingURL=User.js.map